import Vue from 'vue';
import App from './App.vue';
import router from './router/router.js';
import store from './store/index';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faStopwatch, faMaximize, faMinimize, faHouse, faShieldHalved, faBook } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

library.add(faStopwatch, faMaximize, faMinimize, faHouse, faShieldHalved, faBook);

Vue.config.productionTip = false;
Vue.component('font-awesome-icon', FontAwesomeIcon);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
